import React, { Component } from "react";
import { Swipeable, EventData } from "react-swipeable";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import { IImage } from "../../models/Image";
import DescriptionText from "../../laco-common/components/DescriptionText";
import "./ImageGalleryPaging.scss";
import ImageView from "../ui/Media/ImageView";

type ImageGalleryPagingProps = {
	images: IImage[];
};

type ImageGalleryPagingState = {
	selectedIndex: number;
	// selectedMedia: IImage;
};

export default class ImageGalleryPaging extends Component<ImageGalleryPagingProps, ImageGalleryPagingState> {
	state = {
		selectedIndex: 0,
		// selectedMedia: null,
	};

	get hasNext(): boolean {
		return this.props.images && this.props.images.length > 1;
	}

	get hasPrev(): boolean {
		return this.props.images && this.props.images.length > 1;
	}

	onNext() {
		let nextIndex: number = this.state.selectedIndex + 1;
		if (nextIndex >= this.props.images.length) {
			nextIndex = 0;
		}
		this.setState({
			selectedIndex: nextIndex,
			// selectedMedia: this.props.images[nextIndex],
		});
	}

	onPrev() {
		let prevIndex: number = this.state.selectedIndex - 1;
		if (prevIndex < 0) {
			prevIndex = this.props.images.length - 1;
		}
		this.setState({
			selectedIndex: prevIndex,
			// selectedMedia: this.props.images[prevIndex],
		});
	}

	render() {
		if (!this.props.images?.length) return <div />;

		const selectedMedia: IImage = this.props.images[this.state.selectedIndex];

		return (
			<div className="w-100 image-gallery-paging-container">
				<Swipeable
					onSwipedLeft={this.hasPrev ? (e: EventData) => this.onPrev() : undefined}
					onSwipedRight={this.hasNext ? (e: EventData) => this.onNext() : undefined}
				>
					<div className="media-content">
						<img
							className="main-img"
							src={selectedMedia.url}
							title={selectedMedia.title}
							alt={selectedMedia.title}
						></img>

						{this.props.images.length > 1 && (
							<div className="thumbnail-images d-inline-flex flex-wrap mt-4 justify-content-center w-100">
								{this.props.images.map((img: IImage, i: number) => {
									return (
										<ImageView
											className={clsx(this.state.selectedIndex === i && "selected")}
											image={img}
											onClick={() => {
												this.setState({ selectedIndex: i });
											}}
											viewWidth={50}
											viewHeight={50}
											key={i}
										/>
									);
								})}
							</div>
						)}

						{this.hasNext && (
							<IconButton
								edge="start"
								color="default"
								className="icon-btn-outlined float-right page-arrow-btn page-next-btn"
								onClick={(e) => {
									e.preventDefault();
									this.onNext();
								}}
							>
								<ArrowForwardIcon />
							</IconButton>
						)}
						{this.hasPrev && (
							<IconButton
								edge="start"
								color="default"
								className="icon-btn-outlined float-left page-arrow-btn page-prev-btn"
								onClick={(e) => {
									e.preventDefault();
									this.onPrev();
								}}
							>
								<ArrowBackIcon />
							</IconButton>
						)}
					</div>

					<React.Fragment>
						<p className="image-desc text-left mt-3">{/* <DescriptionText text={media.desc} /> */}</p>
					</React.Fragment>
					{/* {this.props.children} */}
				</Swipeable>
			</div>
		);
	}
}
